module.exports = __webpack_public_path__ + "static/img/81123D_3_4_R_20220702_LC.0cf75c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81123D_3_4_R_20220702_LC.png
// module id = GLlG
// module chunks = 0